module.exports = __webpack_public_path__ + "img/slide4-2.6db09b10.png";